import { lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { SuspensedView } from '@components/SuspensedView'

import { CashierLayout } from '@/layouts/CashierLayout'
import { MasterLayout } from '@/layouts/MasterLayout'

const CartRoutes = lazy(() => import('@/routes/cashier/CartRoutes'))
const ShiftPage = lazy(() => import('@/pages/cashier/shift/ShiftPage'))
const RetailRoutes = lazy(() => import('@/routes/cashier/RetailRoutes'))

const CashierRoutes = () => {
  return (
    <Routes>
      <Route element={<CashierLayout />}>
        <Route element={<MasterLayout />}>
          <Route
            path="shift/*"
            element={
              <SuspensedView>
                <ShiftPage />
              </SuspensedView>
            }
          />

          <Route
            path="cart/*"
            element={
              <SuspensedView>
                <CartRoutes />
              </SuspensedView>
            }
          />
        </Route>

        <Route
          path="retail/*"
          element={
            <SuspensedView>
              <RetailRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
      </Route>
    </Routes>
  )
}

export { CashierRoutes }
